import React from "react";
import { useTranslation } from "react-i18next";
import { ExpandMore } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./data-edit-collapse-header.style";
import { MyHrDataEditCollapseHeaderBadge } from "my-hr/components";

type MyHrDataEditCollapseHeaderProps = {
  handleExpandClick: React.MouseEventHandler<HTMLButtonElement>;
  expanded: boolean;
  type: string;
  createdDateAt: string;
  approvedAt: string | null;
  rejectedAt: string | null;
  typeGroup: string;
  isMobile: boolean;
};

export const MyHrDataEditCollapseHeader = ({
  handleExpandClick,
  expanded,
  type,
  createdDateAt,
  approvedAt,
  rejectedAt,
  typeGroup,
  isMobile,
}: MyHrDataEditCollapseHeaderProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Box>
      <Box
        className={
          expanded === true
            ? classes.backgroundColorOnCollapse
            : classes.backgroundColorOffCollapse
        }
        padding="0px 16px"
      >
        <Box
          padding={isMobile ? "16px 0px" : "4px 0px"}
          display="flex"
          flexDirection="row"
          justifyContent={isMobile ? "flex-start" : "space-between"}
          alignItems="center"
        >
          <Box display="contents" />
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            flexDirection={isMobile ? "column" : "row"}
          >
            <Box display="flex" flexDirection="row" alignItems="center">
              <Box height="8px" />
              <Typography variant="h6">{t("OC_REQUEST")}</Typography>
              <Box width="6px" />
              <Box
                style={{
                  border: `1px solid ${theme.palette.gray80.main}`,
                  borderRadius: 12,
                  paddingLeft: 12,
                  paddingRight: 12,
                  paddingTop: 2,
                  paddingBottom: 2,
                }}
              >
                {typeGroup === "temporaryAddress"
                  ? t("MY_HR_TEMPORARY_ADDRESS")
                  : typeGroup === "permanentAddress"
                    ? t("MY_HR_PERMANENT_ADDRESS")
                    : typeGroup === "serviceAddress"
                      ? t("MY_HR_SERVICE_ADDRESS")
                      : typeGroup === "name"
                        ? t("OC_NAME")
                        : typeGroup === "mothersName"
                          ? t("MY_HR_MOTHERS_NAME")
                          : t(`MY_HR_${type?.toUpperCase()}`)}
              </Box>
              <Box width="15px" />
              <Box paddingRight="28px" />
            </Box>
            {isMobile && <Box height="10px" />}
            <Box
              display="flex"
              alignItems="center"
              width={isMobile ? "100%" : "auto"}
              justifyContent={isMobile ? "space-between" : "unset"}
            >
              <Box>
                {approvedAt === null && rejectedAt === null ? (
                  <MyHrDataEditCollapseHeaderBadge
                    badgeName={t("OC_REQUESTED")}
                    border={`1px solid ${theme.palette.yellowBase.main}`}
                  />
                ) : approvedAt !== null && rejectedAt === null ? (
                  <MyHrDataEditCollapseHeaderBadge
                    badgeName={t("OC_APPROVED")}
                    border={`1px solid ${theme.palette.greenBase.main}`}
                  />
                ) : (
                  <MyHrDataEditCollapseHeaderBadge
                    badgeName={t("OC_REJECTED")}
                    border={`1px solid ${theme.palette.primary.main}`}
                  />
                )}
                <Box
                  style={{
                    fontSize: "10px",
                    marginTop: "3px",
                    color: theme.palette.gray60.main,
                  }}
                >
                  {createdDateAt}
                </Box>
              </Box>
              <Box width="22px" />
            </Box>
          </Box>
          <IconButton
            id={
              typeGroup === "name" || typeGroup === "mothersName"
                ? `collapse-header-button-${typeGroup}`
                : `collapse-header-button-${type}-${expanded}`
            }
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
            style={
              expanded
                ? {
                    padding: 0,
                    transform: "rotate(180deg)",
                  }
                : {
                    padding: 0,
                  }
            }
          >
            <ExpandMore />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default MyHrDataEditCollapseHeader;
